import EndingPage from './EndingPage';

export default EndingPage;
